// Shared data for the national platform "Играта на Имотите"

export const TICKET_2027 = {
  url: "https://buy.stripe.com/6oU28qfrueFI6tmaDw2go0v",
  price: 34,
  currency: "EUR",
  label: "Early Bird — 34 €",
  contentName: "Early Bird — Играта на Имотите Варна 2027",
  contentId: "early-bird-2027-34",
};

export const VARNA_2027 = {
  city: "Варна",
  date: "23 октомври 2027",
  dateShort: "23.10.2027",
  venue: "Мястото се обявява скоро",
};

const ASSETS = "https://customer-assets.emergentagent.com/job_afe027c3-a313-4e93-840c-5cce45d2042c/artifacts";

// Real photos from the Varna 2026 event (24.10.2026)
export const EVENT_2026_PHOTOS = [
  { src: `${ASSETS}/og3i277w_IMG_6407%202.webp`, alt: "Публиката на Играта на Имотите 2026" },
  { src: `${ASSETS}/ggfwzfb9_IMG_6391.webp`, alt: "Пълна зала — Играта на Имотите Варна 2026" },
  { src: `${ASSETS}/snbzs21e_IMG_6380%202.webp`, alt: "Сцена и лектори — Играта на Имотите 2026" },
  { src: `${ASSETS}/s5gz6184_IMG_6384%202.webp`, alt: "Атмосфера от събитието — Варна 2026" },
];

// Curated stock imagery (design_guidelines.json)
export const IMG = {
  heroBg: "https://images.unsplash.com/photo-1542732351-fa2c82b0c746?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHszfHxsdXh1cnklMjBldmVudCUyMGNvbmZlcmVuY2UlMjBzdGFnZSUyMGxpZ2h0c3xlbnwwfHx8fDE3OTEyMDI4MTV8MA&ixlib=rb-4.1.0&q=85",
  sofia: "https://images.unsplash.com/photo-1702191340475-11200f87ec5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxidWxnYXJpYSUyMGFyY2hpdGVjdHVyZSUyMEV1cm9wZWFuJTIwY2l0eSUyMGFlcmlhbHxlbnwwfHx8fDE3OTMwMTk0Nzl8MA&ixlib=rb-4.1.0&q=85",
  plovdiv: "https://images.unsplash.com/photo-1633377379199-c42717a3534f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxwbG92ZGl2JTIwYnVsZ2FyaWElMjBvbGQlMjB0b3duJTIwcm9tYW4lMjB0aGVhdGVyJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MzAxOTQ3NXww&ixlib=rb-4.1.0&q=85",
  varna: "https://images.unsplash.com/photo-1781978603498-138f85556048?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjb2FzdGFsJTIwY2l0eSUyMG1hcCUyMGFlcmlhbCUyMG5pZ2h0JTIwbGlnaHRzfGVufDB8fHx8MTc5MTIyOTE5Nnww&ixlib=rb-4.1.0&q=85",
  arch1: "https://images.unsplash.com/photo-1712567604499-08f207054260?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHxfHxtb2Rlcm4lMjBkYXJrJTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MzAxOTQ3NXww&ixlib=rb-4.1.0&q=85",
  arch2: "https://images.unsplash.com/photo-1646333915428-de1c2a92faf3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBkYXJrJTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJlJTIwc2t5c2NyYXBlciUyMGdsYXNzJTIwaW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8fDE3OTMwMTk0NzV8MA&ixlib=rb-4.1.0&q=85",
  arch3: "https://images.unsplash.com/photo-1552925766-63ab07391e02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkYXJrJTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJlJTIwc2t5c2NyYXBlciUyMGdsYXNzJTIwaW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8fDE3OTMwMTk0NzV8MA&ixlib=rb-4.1.0&q=85",
  finale: "https://images.unsplash.com/photo-1578426187376-19bd5aeaeaa0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHxfHxkYXJrJTIwbHV4dXJ5JTIwYnVpbGRpbmclMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3OTMwMTk0Nzl8MA&ixlib=rb-4.1.0&q=85",
};

export const CITIES = [
  {
    id: "sofia",
    name: "София",
    status: "Очаквайте скоро",
    image: IMG.sofia,
    upcoming: true,
  },
  {
    id: "plovdiv",
    name: "Пловдив",
    status: "Очаквайте скоро",
    image: IMG.plovdiv,
    upcoming: true,
  },
  {
    id: "varna",
    name: "Варна",
    status: VARNA_2027.date,
    image: IMG.varna,
    upcoming: false,
    next: true,
  },
];

export const PILLARS = [
  {
    title: "Данни, не предположения",
    text: "Пазарни статистики, реални тенденции, лихви, кредитиране и икономически анализи.",
    num: "01",
  },
  {
    title: "Стратегии, не обещания",
    text: "Доходност от наем, сделки, ремонти и препродажби, ново строителство, финансиране и управление на риска.",
    num: "02",
  },
  {
    title: "Хора, не просто контакти",
    text: "Инвеститори, предприемачи, строители, банки, експерти и хора, които вземат важни имотни решения.",
    num: "03",
  },
];

export const AUDIENCES = [
  {
    title: "Инвеститори",
    text: "За хора, които искат да увеличават портфолиото си и да намират по-добри сделки.",
  },
  {
    title: "Купувачи на първи имот",
    text: "За хора, които искат да избегнат скъпите грешки при една от най-важните покупки в живота си.",
  },
  {
    title: "Строители и предприемачи",
    text: "За компаниите, които създават бъдещето на градовете ни.",
  },
  {
    title: "Имотни професионалисти",
    text: "За брокери, консултанти, финансисти и експерти, които искат да бъдат една крачка пред пазара.",
  },
  {
    title: "Хора с капитал",
    text: "За всички, които търсят възможности, диверсификация и инвестиционна перспектива.",
  },
];

export const TOPICS = [
  { title: "Накъде вървят цените?", text: "Данни, тенденции, предлагане и реално търсене." },
  { title: "Какво става с кредитите?", text: "Лихви, банки, финансиране и достъпност на жилищата." },
  { title: "Къде са инвестиционните възможности?", text: "Реални стратегии, доходност и оценка на риска." },
  { title: "Ново строителство и бъдещето на градовете", text: "Инфраструктура, нови проекти и развитие на кварталите." },
  { title: "Как се правят по-добри имотни сделки?", text: "От покупката и преговорите до продажбата и управлението." },
  { title: "Имотният пазар на утрешния ден", text: "Демография, технологии, икономика и нови модели на живот." },
];

export const PARTNERS_2026 = [
  { name: "УниКредит Булбанк", src: "/partners/unicredit.png" },
  { name: "КСБ", src: "/partners/ksb.png" },
  { name: "ERA", src: "/partners/era.png" },
  { name: "S Properties", src: "/partners/sproperties.jpg" },
  { name: "NEW TOWER", src: "/partners/newtower.png" },
  { name: "Credit Zone", src: "/partners/kz.png" },
  { name: "BIGLA III", src: "/partners/bigla.png" },
  { name: "LEX BUILD", src: "/partners/lexbuild.webp" },
  { name: "Изолации ЕООД", src: "/partners/izolatsii.png" },
  { name: "Altcoins.bg", src: "/partners/altcoins.png" },
  { name: "Топливо АД", src: "/partners/toplivo.png" },
  { name: "VivEra Design Studio", src: "/partners/vivera.png" },
  { name: "Варненско Утро", src: "/partners/varnensko-utro.png" },
];

export const PARTNERSHIP_TYPES = [
  "Генерален спонсор",
  "Основен партньор",
  "Изложител / Щанд",
  "Медиен партньор",
  "Стратегически партньор",
  "Друго",
];

export const PARTNERSHIP_BENEFITS = [
  { title: "Достъп до релевантна аудитория", text: "Срещнете хора с реален интерес към имотни сделки, финансиране и инвестиции." },
  { title: "Видимост на бранда", text: "Представете компанията си преди, по време и след събитието." },
  { title: "Бизнес контакти", text: "Изградете нови отношения с предприемачи, инвеститори и представители на сектора." },
  { title: "Присъствие на място", text: "Възможности за щанд, представяне, демонстрации и директен контакт с посетителите." },
  { title: "Партньорство в три града", text: "Възможност за участие в бъдещите събития в София, Пловдив и Варна." },
];
